<template>
  <div
    class="image-map-container"
    ref="imageMapContainer"
    id="image-map-pro"
  ></div>
</template>

<script>
  import moment from 'moment';
  import * as d3 from 'd3';
  moment.locale('es');
  export default {
    props: ['evento'],
    data() {
      return {
        mostrarDiv: false,
        idlocalidad: '',
        mostrarMiniMap: false,
      };
    },

    mounted() {
      const script = document.createElement('script');
      script.src = 'https://imagemappro.com/image-map-pro.min.js'; // Ruta a tu archivo image-map-pro.min.js
      script.async = true;

      script.onload = () => {
        this.$nextTick(async () => {
          /* console.log(this.evento.auditorio_mapeado.mapeo); */

          // Fetch the JSON file
          try {
            const response = await fetch('/js/mapa.json'); // Ruta a tu archivo mapa.json
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            const mapeo = await response.json(); // Parsear el contenido del archivo JSON

            // Initialize ImageMapPro with the fetched JSON data
            window.ImageMapPro.init('#image-map-pro', mapeo);
            window.ImageMapPro.subscribe((action) => {
              console.log(action.type);
              if (action.type === 'objectClick') {
                let cadena = action.payload.object;
                let opcion = cadena.split(' - ')[0];
                this.$emit('valorEnviado', opcion);
              }
            });
          } catch (error) {
            console.error('Error fetching the mapa.json file:', error);
          }
        });
      };
      document.body.appendChild(script);
    },
    methods: {
      mapasientos() {
        this.mostrarDiv = false;
      },
    },
  };
</script>
<style>
  .container {
    position: relative;
    /* Asegúrate de que el contenedor tenga posición relativa */
    overflow: hidden;
    /* Oculta el contenido que se sale del contenedor */
  }

  @media (width <=550px) {
    div.imp-ui-navigator-window-image {
      display: none;
    }
  }

  .responsive-map {
    width: 100%;
    height: auto;
    object-fit: cover;
  }

  @media (max-width: 750px) {
    div.imp-ui-element.imp-ui-navigator-root {
      display: none;
    }
  }
</style>
